<div class="nav-item" [class.active]="isActive">
  <div class="button-container">
    <div class="notification-badge body-xs semibold" *ngIf="count && count > 0" role="status">
      {{ count }}
    </div>
    <div class="icon-box">
      <ptl-icon [icon]="icon" [size]="size"></ptl-icon>
    </div>
  </div>
  <div class="body-xs bold text" *ngIf="text">{{ text }}</div>
</div>
